// This is a mulipurpose input field, which features
// A clear button
// Tags/pills in addition to normal text input. Will be used for JSON values here.

import React from "react";
import "./PalamoaInputField.scss";

import { Icon } from "react-icons-kit";
import { xCircle as deleteIcon } from "react-icons-kit/feather/";

class PalamoaInputField extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isHovered: false };
  }
  render() {
    let {
      isFocused,
      onFocus,
      value,
      onChange,
      onClick,
      onBlur,
      onClear,
      method,
      //transformedValue
    } = this.props;
    let inputCSS = isFocused ? " focused" : "";
    return (
      <div
        className={"palamoa-input-field-wrapper" + inputCSS}
        onMouseOver={evt => {
          this.setState({ isHovered: true });
        }}
        onMouseLeave={evt => {
          this.setState({ isHovered: false });
        }}
      >
         
        {method === "JSON" && <PalamoaInputFieldPill text={value} />}
                      
                      
        <input
          type="text"
          value={method === "manual" ? value : ""}
          onChange={onChange}
          onClick={onClick}
          onBlur={evt=>{this._shouldBlur(evt) && onBlur(evt)}}
          onFocus={onFocus}
        />

        
        {isFocused && <PalamoaInputFieldClearButton onClear={onClear} />}
      </div>
    );
  }

  _shouldBlur(evt) {
    return (!(
      evt.relatedTarget &&
      evt.relatedTarget.classList.contains("palamoa-input-field-clearbutton")
    )) 
  }
}

class PalamoaInputFieldClearButton extends React.Component {
  render() {
    let { onClear } = this.props;
    return (
      <div
        className="palamoa-input-field-clearbutton"
        tabIndex="-1"
        onClick={onClear}
      >
        <Icon size={25} icon={deleteIcon} />
      </div>
    );
  }
}

class PalamoaInputFieldPill extends React.Component {
  render() {
    let { text } = this.props;
    return <div className="palamoa-input-field-pill">{text}</div>;
  }
}

export default PalamoaInputField;
